const GoogleConstants = {
  maps_domain: 'https://www.google.com/maps/place/',
  map_key: 'AIzaSyCvUSMVTsqlD7uj4yfQFOluluBcDiwGkwo',
};

export default GoogleConstants;
